












import { defineComponent, reactive, toRefs, onMounted, watch, onBeforeUnmount, ref } from '@vue/composition-api'
import AlertArea from "../../components/AlertArea.vue"
import MasterMainteTab from "../../components/MasterMainteTab.vue"
import CramStudentTable from "../../components/CramStudentTable.vue"

export interface Data {
  tabNo: number
}

export default defineComponent({
  components: {
    "master-mainte-tab": MasterMainteTab,
    "cram-student-table": CramStudentTable,
    "alert-area": AlertArea,
  },
  setup(props, context){

    /************************************************************
     * data
     ************************************************************/

    const state = reactive<Data>({
      tabNo: 4,
    });

    return {
      ...toRefs(state),
    };
  }
});

